export function getItemDetailSlug(
  name: string,
  slug: string | null | undefined,
  itemId: number
): string {
  if (slug) {
    const normalizedSlug = slug
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')

    const itemIdSuffix = `-${itemId}`
    return normalizedSlug.endsWith(itemIdSuffix)
      ? normalizedSlug.slice(0, -itemIdSuffix.length)
      : normalizedSlug
  }

  const nameSlug = name
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')

  return nameSlug
}
